import React, { memo, useCallback } from "react";
import { Link } from "react-router-dom";
import { useCart } from "../../context/CartContext";
import { X } from "lucide-react";

function CartItems({ item }) {
  const { updateQuantity, removeItem } = useCart();

  const {
    _id,
    thumbnail: image,
    slug,
    title,
    variantName,
    quantity,
    price,
    mrp,
  } = item;

  const numPrice = Number(price);
  const numMrp = Number(mrp);

  const handleRemove = useCallback(() => {
    removeItem(_id);
  }, [removeItem, _id]);

  const handleQuantityChange = useCallback(
    (delta) => {
      const newQuantity = quantity + delta;

      if (newQuantity < 1) return;

      updateQuantity(_id, newQuantity);
    },
    [updateQuantity, _id, quantity],
  );

  return (
    <div className="custom-cart-item">

      {/* IMAGE */}
      <Link
        to={`/shop/${slug}`}
        className="custom-cart-item-image"
      >
        <img
          src={image}
          alt={title || "Cart Item"}
        />
      </Link>

      {/* CONTENT */}
      <div className="custom-cart-item-content">

        <div className="custom-cart-item-top">

          <Link
            to={`/shop/${slug}`}
            className="custom-cart-item-title"
          >
            {title}
          </Link>

          <button
            type="button"
            className="custom-cart-remove"
            onClick={handleRemove}
            aria-label="Remove item"
          >
            <X size={17} />
          </button>

        </div>

        {variantName && (
          <span className="custom-cart-variant">
            {variantName}
          </span>
        )}

        {/* PRICE */}
        <div className="custom-cart-price-row">

          <span className="custom-cart-item-price">
            ₹{numPrice.toFixed(0)}
          </span>

          {!isNaN(numMrp) && numMrp > numPrice && (
            <span className="custom-cart-old-price">
              ₹{numMrp.toFixed(0)}
            </span>
          )}

        </div>

        {/* BOTTOM */}
        <div className="custom-cart-item-bottom">

          <div className="custom-cart-qty">

            <button
              type="button"
              onClick={() => handleQuantityChange(-1)}
            >
              −
            </button>

            <span>{quantity}</span>

            <button
              type="button"
              onClick={() => handleQuantityChange(1)}
            >
              +
            </button>

          </div>

          <strong className="custom-cart-item-total">
            ₹{(numPrice * quantity).toFixed(0)}
          </strong>

        </div>

      </div>
    </div>
  );
}

export default memo(CartItems);